export default function initTextResize() {
	function handlerTextSizes() {
		const containers = document.querySelectorAll('.counter-wrap');
		let fontSize = 192;

		containers.forEach((container) => {
			const containerWidth = container.clientWidth;
			const text = container.querySelector('.counter');

			text.style.fontSize = fontSize / 16 + 'rem';

			while (text.scrollWidth > containerWidth && fontSize > 10) {
				fontSize--;
				text.style.fontSize = fontSize / 16 + 'rem';
			}
		});
	}

	handlerTextSizes();
	window.addEventListener('resize', handlerTextSizes);
}